'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import gsap from 'gsap'
import ParallaxFx from '../fx/ParallaxFxVert'
import RevealFx from '../fx/RevealFx'
import PlayerVideo from '../modules/Player'


let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--civiIndex'
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()


    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, Env.introBaseDelay);
        this.setupVideos()
    }

    intro()
    {
      const $intro = this.view.querySelector('.jsIntro')
      const $elementsA = [$intro.querySelectorAll('.jsFxA'),this.view.querySelector('.jsChapter')]
      const $elementsB = [$intro.querySelectorAll('.jsFxB')]
      const $elementsC = [$intro.querySelectorAll('.jsFxC')]
      const $elementsD = [$intro.querySelectorAll('.jsFxD')]
      const tl = gsap.timeline()

      tl.add([
        gsap.fromTo($elementsA , { autoAlpha: 0 , y : 10 },{ autoAlpha: 1 , y : 0, ease:'cubic.out' , duration:1 , stagger:.2 }),
        gsap.fromTo($elementsB , { autoAlpha: 0, y: 20 },{ autoAlpha: 1 , y:0, ease:'cubic.out' , duration:1 , stagger:.2 }),
        gsap.fromTo($elementsC , { autoAlpha: 0 },{ autoAlpha: 1 , ease:'cubic.out' , duration:1 , stagger:.2 }),
        gsap.fromTo($elementsD , { x: '100%' },{ x: '0%' , ease:'power3.out' , duration:1 , delay : .4 }),
      ])
    }

    setupVideos()
    {
      const $players = this.view.querySelectorAll('.jsPlayer')
      for(let $player of $players) {
        const instance = new PlayerVideo($player)
        instance.setup()

      }
    }

}

page = Barba.BaseView.extend({
    namespace: 'civiIndex',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
